
import React, { useState, useEffect } from 'react';
import WhiteLogo from '../../resource/img/asset/logo/logo_white.png';

const POPUP_STORAGE_KEY = 'popupDontShowUntil';

const InitialPopup = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [dontShowToday, setDontShowToday] = useState(false);

    useEffect(() => {
        const dontShowUntil = localStorage.getItem(POPUP_STORAGE_KEY);
        if (dontShowUntil && new Date().getTime() < parseInt(dontShowUntil, 10)) {
            setIsOpen(false);
        } else {
            setIsOpen(true);
        }
    }, []);

    const handleClose = () => {
        if (dontShowToday) {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            localStorage.setItem(POPUP_STORAGE_KEY, tomorrow.getTime().toString());
        }
        setIsOpen(false);
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md flex flex-col overflow-hidden">
                <div className="p-4 bg-[#E6002D] flex items-center">
                    <img src={WhiteLogo} alt="KFA Logo" className="h-6 mr-4"/>
                    <h2 className="text-lg font-semibold text-white">대한축구협회 공지</h2>
                </div>
                <div className="p-6 flex-grow overflow-y-auto" style={{ maxHeight: '50vh' }}>
                    <h3 className="font-bold text-gray-800 mb-3">서버 이전에 따른 이용 제한 안내</h3>
                    <p className="text-sm text-gray-700">
                        협회 서버 이전 작업으로 아래 기간 동안 신규 회원가입 및 통합회원 전환 서비스 이용이 제한됩니다.
                        <br/><br/>
                        <span className="font-medium">· 작업 기간:</span> 2025년 12월 15일(월) 00:00 ~ 12월 31일(수) 23:59
                    </p>
                </div>
                <div className="p-4 bg-gray-50 rounded-b-lg flex justify-between items-center">
                    <div className="flex items-center">
                        <input
                            type="checkbox"
                            id="dont-show"
                            checked={dontShowToday}
                            onChange={(e) => setDontShowToday(e.target.checked)}
                            className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <label htmlFor="dont-show" className="ml-2 text-sm text-gray-900">
                            오늘 하루 안 열기
                        </label>
                    </div>
                    <button
                        onClick={handleClose}
                        className="px-4 py-2 bg-[#E6002D] text-white text-sm font-medium rounded-md hover:bg-[#c40026] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E6002D]"
                    >
                        닫기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InitialPopup;
